// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { Token } from '../services/token';

// export const authInterceptor: HttpInterceptorFn = (req, next) => {

//   const tokenService = inject(Token);
//   const token = tokenService.getToken();

//   if (token) {
//     req = req.clone({
//       setHeaders: {
//         Token: token
//       }
//     });
//   }

//   return next(req);
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { Token } from '@core/services/token';
import { SessionService } from '@core/services/session';
import { AuthService } from '@core/services/auth';
import { DomainService } from '@core/services/domain';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const tokenService = inject(Token);
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);
  const domainService = inject(DomainService);
  const router = inject(Router);

  const token = tokenService.getToken();

  if (token) {
    req = req.clone({
      setHeaders: {
        Token: token
      }
    });
  }

  return next(req).pipe(

    catchError((error) => {

      if (error.status === 401) {
        const returnUrl = router.url;
        const reqFrom = String(sessionStorage.getItem('ReqFrom') ?? '')
          .trim()
          .toLowerCase();
        const studentId = Number(sessionStorage.getItem('studentId'));

        authService.logout();
        sessionService.clearAdmissionStateKeepDomainContext();
        domainService.resetDomainCache();

        const queryParams: Record<string, string> = { returnUrl };
        if (reqFrom) {
          queryParams['reqFrom'] = reqFrom;
        }
        if (studentId > 0) {
          queryParams['studentId'] = String(studentId);
        }

        router.navigate(['/session-timeout'], { queryParams, replaceUrl: true });
      }

      if (error.status === 403) {
        router.navigate(['/403']);
      }

      if (error.status === 500) {
        router.navigate(['/500']);
      }

      return throwError(() => error);

    })

  );
};

